import { extractErrorDetail } from "@src/appV2/api/extractErrorDetail";
import { showErrorToast } from "@src/appV2/lib/Notifications";
import { ResponseError } from "superagent";

export const getErrorMessage = (error: unknown, msg = "request failed"): string =>
  extractErrorDetail(error) ?? msg;

export const handleApiError = (error: unknown) => {
  showErrorToast(getErrorMessage(error));
};

export const parseObjectErrorResponse = (error: string | Record<string, unknown>) => {
  if (typeof error === "object") {
    return error;
  }

  try {
    return JSON.parse(error);
    // FIXME: Automatically disabled during ESLint config update
  } catch {
    return {};
  }
};

export function isRequestErrorResponse(error: unknown): error is ResponseError {
  return error instanceof Error && "response" in error && "status" in error;
}
